
import TextLink from './../../components/TextLink';

export default function PageNotFound(){
    return(
        <div className="popup-bg">
        <div className="popup-window bg-white p-8 flex flex-col gap-3 items-center">
            <img className="h-24" alt="logo" src = "/iconslimsvet/logo.png"/>
            <p className="font-medium text-dark-green text-md">Erreur 404: Page non trouvée</p>
            <TextLink className="" to="/main" text="Retourner à l'accueil"/>
        </div>
    </div>
    );
}
